import { ICompileService } from "angular";
import { startCase } from "lodash";
import {
  booleanValueGetterFactory,
  dateTimeValueGetter,
  dateValueGetter,
  ValueGetter,
} from "../cells/valueGetters";
import { ColDef } from "./colDef";
import { FilterProvider } from "./filters/FilterProvider";

export const vsName = "columnDefinitionService";
export interface PermissionColDef {
  requiresPermission?: string;
}
export interface linkColDef extends PermissionColDef {
  width?: number;
  colId: string;
  iconClass: string;
  stateExpression: string;
  headerName: string;
  requiresPermission?: string;
}

export type simpleColDef = {
  field: string;
  header?: string;
  valueGetter?: ValueGetter;
  csvValueGetter?: ValueGetter;
  suppressMenu?: boolean;
  suppressSorting?: boolean;
  hide?: boolean;
  filter?: Function;
  requiresPermission?: string;
};

export class ColumnDefinitionService {
  static $inject = ["$compile"];
  constructor(private readonly $compile: ICompileService) {}

  getLinkColDef(config: linkColDef): ColDef {
    return {
      headerName: config.headerName,
      template: `<a ui-sref="${config.stateExpression}"><i class="${config.iconClass}"></i></a>`,
      colId: config.colId,
      width: config.width ?? 20,
      requiresPermission: config.requiresPermission,
    };
  }

  getBooleanColDef(config: simpleColDef): ColDef {
    return this.simpleColDef(
      config,
      config.filter ??
        new FilterProvider(config.field, this.$compile)
          .defaultBooleanFilters()
          .getGridFilterFactory(),
      booleanValueGetterFactory()
    );
  }

  getNumberColDef(config: simpleColDef): ColDef {
    return this.simpleColDef(
      config,
      config.filter ??
        new FilterProvider(config.field, this.$compile)
          .defaultNumberFilters()
          .getGridFilterFactory()
    );
  }

  getStringColDef(config: simpleColDef): ColDef {
    return this.simpleColDef(
      config,
      config.filter ??
        new FilterProvider(config.field, this.$compile)
          .defaultStringFilters()
          .getGridFilterFactory()
    );
  }

  getDateColDef(config: simpleColDef): ColDef {
    return this.simpleColDef(
      config,
      config.filter ??
        new FilterProvider(config.field, this.$compile)
          .defaultDateFilters()
          .getGridFilterFactory(),
      dateValueGetter
    );
  }

  getDateTimeColDef(config: simpleColDef): ColDef {
    return this.simpleColDef(
      config,
      config.filter ??
        new FilterProvider(config.field, this.$compile)
          .defaultDateFilters()
          .getGridFilterFactory(),
      dateTimeValueGetter
    );
  }

  simpleColDef(
    config: simpleColDef,
    filter?: Function,
    valueGetter?: ValueGetter
  ): ColDef {
    return {
      field: config.field,
      headerName: this.getHeader(config),
      filter,
      valueGetter: config.valueGetter ?? valueGetter,
      csvValueGetter: config.csvValueGetter,
      suppressMenu: config.suppressMenu,
      suppressSorting: config.suppressSorting,
      hide: config.hide,
      requiresPermission: config.requiresPermission,
    };
  }

  private getHeader(config: simpleColDef): string {
    return config.header ?? startCase(config.field);
  }
}
